import React, { useState } from "react";
// reactstrap components
import {
    Container,
    Button
} from "reactstrap";
import { Route, Redirect } from 'react-router-dom';

import { authenticationService } from '_services';
import { handleResponse, authHeader } from '_helpers';

import IndexNavbar from "components/Navbars/IndexNavbar.js";
import IndexHeader from "components/Headers/IndexHeader2.js";
import DarkFooter from "components/Footers/DarkFooter.js";
import DefaultFooter from "components/Footers/DefaultFooter.js";

const CameraTest = (props) => {
    var moment = require('moment');
    require('moment/locale/th');

    const [clientHeight, setClientHeight] = useState('');
    const [tokSession, setSession] = useState('');
    const [tokToken, setToken] = useState('');
    const [lineTrangskin, setLineTrangskin] = useState("");

    const teleID = (props.match.params.teleID !== undefined) ? props.match.params.teleID : null;

   
    React.useEffect(() => {
        /*
        var element = document.querySelector('#hardware-setup');
     
        var component = window.createOpentokHardwareSetupComponent(element, {
            insertMode: 'append'
        }, function (error) {
            if (error) {
                console.error('Error: ', error);
                document.querySelector('#hardware-setup').innerHTML = '<strong>Error getting ' +
                    'devices</strong>: ' + error.message;
                return;
            }

            //var button = document.createElement('button');
            //button.onclick = component.destroy;
            //button.appendChild(document.createTextNode('Destroy'));
            //element.appendChild(button);

        });
        console.log('test')
        console.log(component)
        */

        document.body.classList.add("landing-page");
        document.body.classList.add("sidebar-collapse");
        document.documentElement.classList.remove("nav-open");
        return function cleanup() {
            document.body.classList.remove("landing-page");
            document.body.classList.remove("sidebar-collapse");
        };

    }, []);

    const handleCall = e => {

        if (teleID != null) {
            window.location.href = "/vdocall/" + teleID;
        }
    };

    return (
        <>
            <div className="main">
                <h2 className="title text-center">กรุณาตรวจสอบกล้องและไมค์ให้พร้อมก่อนการเข้าสนทนา</h2>
                <div id="hardware-setup"></div>  

                <Button
                    type="submit"
                    block
                    className="btn-round"
                    color="info"
                    size="lg"
                    onClick={handleCall}
                >
                    เข้าสู่การสนทนา
                 </Button>
            </div>

        </>
    );
    }

export default CameraTest;
